import { InputWithLabel } from '@adotel/components'
import { useMutation } from '@apollo/client'
import {
  Button,
  CircularProgress,
  Grid,
  Hidden,
  Typography
} from '@material-ui/core'
import React from 'react'
import { toast } from 'react-toastify'

import AdotelLogo from '../../assets/images/AdPoint1.png'
import BottomCurve from '../../assets/images/Vector.svg'
import ellipseImg from '../../assets/images/ellipse.svg'
import AdotelLogoForLogin from '../../assets/images/logo.svg'
import { UPDATE_USER_PHONE_NUMBER_MUTATION } from '../../graphql/auth'
import { iranMobileRegex } from '../../helpers/regex'
import { getTranslate } from '../../localization'
import { UserPhoneNumber, UserPhoneNumberResponse } from '../../types/auth'
import useStyles from './styles/verifyNumber.style'

type VerifyNumberProps = {
  input: UserPhoneNumber
  setInput: React.Dispatch<React.SetStateAction<UserPhoneNumber>>
  year: string
  setStep: React.Dispatch<React.SetStateAction<number>>
  setTimeLeftInSeconds: (
    value: number | ((prevState: number) => number)
  ) => void
}

const VerifyNumber = ({
  input,
  setInput,
  year,
  setStep,
  setTimeLeftInSeconds
}: VerifyNumberProps) => {
  const classes = useStyles()

  const [UpdateUserPhoneNumber, { loading }] = useMutation<{
    updateUserPhoneNumber: UserPhoneNumberResponse
  }>(UPDATE_USER_PHONE_NUMBER_MUTATION, {
    notifyOnNetworkStatusChange: true,
    onCompleted: (res) => {
      setTimeLeftInSeconds(res.updateUserPhoneNumber.expiresIn)
      setStep(3)
    },
    onError: (error: any) => {
      toast.error(error.message)
    }
  })

  return (
    <div className={classes.root}>
      <Hidden smDown>
        <div className={classes.logoPaper}>
          <img src={AdotelLogo} alt="Adotel Co." className={classes.logoImg} />
          <div className={classes.copyrightContainer}>
            <Typography>
              ©{year} {getTranslate('Adotel')} .{' '}
              {getTranslate('All Rights Reserved')}
            </Typography>
          </div>
        </div>
      </Hidden>
      <div className={classes.loginPaper}>
        <img src={ellipseImg} alt="adotel" className={classes.ellipseIcon} />
        <div className={classes.formContainer}>
          <img
            src={AdotelLogoForLogin}
            alt="Adotel Co."
            className={classes.logoImgSmall}
          />
          <div className={classes.titleSection}>
            <Typography variant="h1" className={classes.title}>
              {getTranslate('Central Reservation System')}
            </Typography>
            <Typography variant="h4" className={classes.subtitle}>
              {getTranslate('Enter your user information')}
            </Typography>
          </div>
          <Grid className={classes.inputContainer}>
            <InputWithLabel
              label={getTranslate('Phone Number')}
              placeholder="09123456789"
              name="phoneNumber"
              inputSize="small"
              value={input?.phoneNumber}
              onChange={(event) =>
                setInput({ ...input, phoneNumber: event.currentTarget.value })
              }
              fullWidth
              className={classes.emailInput}
            />
          </Grid>
          <Grid className={classes.loginButtonContainer}>
            <Button
              onClick={() => {
                UpdateUserPhoneNumber({
                  variables: {
                    input: input
                  }
                })
              }}
              className={classes.loginButton}
              variant="contained"
              fullWidth
              size="medium"
              type="submit"
              disabled={!iranMobileRegex.test(input.phoneNumber) || loading}>
              <Typography variant="body2" className={classes.loginButtonText}>
                {getTranslate('Verify Number')}
              </Typography>
              {loading && (
                <CircularProgress
                  className={classes.circularProgress}
                  size={16}
                />
              )}
            </Button>
            <Typography
              variant="body2"
              className={classes.backButton}
              onClick={() => {
                setStep(1)
              }}>
              {getTranslate('Back')}
            </Typography>
          </Grid>
          <Grid className={classes.copyrightContainer}>
            <Typography>
              ©{year} {getTranslate('Adotel')} .{' '}
              {getTranslate('All Rights Reserved')}
            </Typography>
          </Grid>
        </div>
      </div>
      <img src={BottomCurve} alt="Adotel Co." className={classes.BottomCurve} />
    </div>
  )
}

export default VerifyNumber
